const _defaultOnError = e => {
    console.error("An error ocurred while requesting the server! " + e.message, e);
};

export const fetchGetJson = function<RespType>(
    url?: string,
    initOrDefault?: RequestInit,
    onError?: (reason: any) => void
) {
    const promise = (fetch
        .bind(
            null,
            url,
            initOrDefault || {
                credentials: "same-origin",
                method: "GET"
            }
        )()
        .then(r => {
            var data = r.json();

            if (data.Errors && data.Errors.length && data.Errors.length > 0) {
                throw new Error(`${data.Errors[0].Exception}: ${data.Errors[0].Message}`);
            }

            return data;
        }) as Promise<RespType>).catch(onError || _defaultOnError);

    return promise;
};

export const UrlSanitise = (u: string): string => {
    const url = new URL(u);
    url.pathname += url.pathname.endsWith("/") ? "" : "/";
    return url.toString();
}
